import { motion } from "framer-motion";
import { Card, CardContent } from "../components/card";
import { Check } from "lucide-react";
import "./Products.css";

const products = [
  {
    name: "ChipServer Essential",
    price: "$345",
    description:
      "Perfect for personal use, designed for users who want a simple and efficient way to store and share files directly from their ChipServer.",
    features: [
      "Compatible with any Wi-Fi smart device",
      "128GB internal storage",
      "Direct file upload to device",
      "Up to 400 Mbp/s upload speed",
      "No external storage needed",
      "Support for 15+ simultaneous users",
      "Wireless Pocket Cloud",
      "50ft+ uninterrupted range",
      "Upload, Download, and share media",
      "Portable, Wireless USB",
    ],
    productId: "733423279",
  },
  {
    name: "ChipServer Plus",
    price: "$495",
    description:
      "A versatile solution for both professional and personal environments, offering enhanced connectivity and external storage options.",
    features: [
      "Compatible with any Wi-Fi smart device",
      "1 USB port included",
      "Compatible with USB type A/3.0 drives",
      "Support for 15+ simultaneous users",
      "View and present files within 50ft+ radius",
      "External SSD support",
      "50ft+ uninterrupted range",
    ],
    productId: "733423280",
  },
  {
    name: "ChipServer Pro",
    price: "$895",
    description:
      "Our most powerful model, designed for professional environments requiring maximum storage and connectivity capabilities.",
    features: [
      "Compatible with any Wi-Fi smart device",
      "256GB Internal Storage + USB port",
      "Direct file upload capability",
      "Up to 400 Mbp/s upload speed",
      "Support for 25+ simultaneous users",
      "No connectivity drop-off",
      "Wireless Pocket Cloud",
      "80ft+ uninterrupted range",
      "Upload, Download, and share media",
    ],
    productId: "733423542",
  },
  {
    name: "Enterprise Solution",
    price: "Contact for Quote",
    description:
      "Transform your organization's data management capabilities with our enterprise-grade solution. Designed for large-scale operations, ChipServer Enterprise offers customizable deployments, dedicated support, and scalable architecture to meet your organization's unique needs.",
    features: [
      "Customized deployment tailored to your organization",
      "Dedicated account management and 24/7 support",
      "Scalable infrastructure for growing teams",
      "Enterprise-grade security and compliance",
      "Comprehensive training and onboarding",
    ],
    productId: null,
  },
];

const formatProductName = (name) =>
  name.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "");

export default function Products() {
  return (
    <div className="products-page">
      <div className="products-header">
        <h1>Our Products</h1>
        <p>
          Choose the perfect ChipServer for your needs. From personal use
          to enterprise solutions, we have a solution that fits your
          requirements!
        </p>
      </div>

      <div className="product-grid">
        {products.map((product, index) => {
          const productHash = product.productId
            ? `#!/${formatProductName(product.name)}/p/${product.productId}`
            : "";

          return (
            <motion.div
              key={product.name}
              className="product-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="card-body">
                <CardContent>
                  <h3>{product.name}</h3>
                  <p className="price" translate="no">
                    {product.price}
                  </p>
                  <p className="description">{product.description}</p>
                  <ul>
                    {product.features.map((feature, i) => (
                      <li key={i}>
                        <Check className="check-icon" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
                <div className="card-footer">
                  <a
                    href={
                      product.productId
                        ? `/store${productHash}`
                        : "/contact"
                    }
                  >
                    <button className="product-button">
                      {product.productId ? "Buy Now" : "Contact for Quote"}
                    </button>
                  </a>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
